import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import { Button } from 'core/components/button';
import { useStore } from 'core/store';
import useStyles from './purchased-offer-banner.styles';

/**
 * Warns staff when the offer they opened is associated with a policy, so it isn't submitted for
 * review or bound a second time (GitHub issue #31622). Looked up when the offer loads
 * (fetchBoundPolicy). Two cases (#35936):
 *  - EXACT: a policy was bound from THIS exact offer — strong "already purchased" wording.
 *  - FUZZY: the member has an active policy at this location / for these cars (a different or
 *    unknown quote) — softer wording, since a member can legitimately hold several policies.
 */
const PurchasedOfferBanner = observer(() => {
  const classes = useStyles();
  const {
    offer: { boundPolicy, boundPolicyIsExact }
  } = useStore();

  if (!boundPolicy) {
    return null;
  }

  const message = boundPolicyIsExact
    ? `This offer has already been purchased — policy ${boundPolicy.id} is on file. Submitting it for review or binding it again would create a duplicate policy.`
    : `This member already has an active policy (${boundPolicy.id}) at this location. A member can hold more than one policy, so review before submitting or binding to avoid a duplicate.`;

  return (
    <div className={classes.banner} role="alert">
      <span className={classes.message}>{message}</span>
      <Button
        variant="contained"
        className={classes.viewButton}
        component={Link}
        to={`/customer/${boundPolicy.accountId}/policy/${boundPolicy.id}`}
      >
        View policy
      </Button>
    </div>
  );
});

export default PurchasedOfferBanner;
